module.exports = __webpack_public_path__ + "static/media/SoybeanIcon.96fe7218.svg";